export default "__VITE_ASSET__CEVHhXIP__"